import classNames from 'classnames';
import { HTMLAttributes } from 'react';

import { SkeletonHeight, SkeletonWidth } from './skeleton.types';

type SkeletonClassName = HTMLAttributes<HTMLSpanElement>['className'];

export interface SkeletonProps {
  className?: SkeletonClassName;
  variant?: 'text' | 'circular' | 'rectangular';
  height?: SkeletonHeight;
  width?: SkeletonWidth;
  inline?: boolean;
}

/**
 * A skeleton placeholder component to indicate if a component is loading
 */
export function Skeleton({ className, variant = 'text', height, width, inline = false }: SkeletonProps) {
  const baseClass: SkeletonClassName = 'block animate-pulse bg-surface-hover';
  const inlineClass: SkeletonClassName = inline ? classNames('inline-block') : undefined;

  if (variant === 'text') {
    return (
      <span
        className={classNames(
          className,
          baseClass,
          inlineClass,
          height,
          width,
          'rounded origin-[0px_55%] scale-x-[1] scale-y-[0.6]',
          `before:content-['_']`,
        )}
      >
        &nbsp;
      </span>
    );
  }

  if (variant === 'circular') {
    return <span className={classNames(className, baseClass, inlineClass, height, width, 'rounded-full')} />;
  }

  if (variant === 'rectangular') {
    return <span className={classNames(className, baseClass, inlineClass, height, width)} />;
  }

  return null;
}

export default Skeleton;
